module.exports = __webpack_public_path__ + "static/media/appstore_de.b37fbda5.svg";